import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import { Field, reduxForm } from 'redux-form';
import './main.less';

import ModalBox from '../../../../shared/modal';
import InputField from '../../../../shared/form-elements/input';
import SelectField from '../../../../shared/form-elements/select/field';
import CheckboxField from '../../../../shared/form-elements/checkbox';

const Form = props => {
	const submit = props.submitCopyOfferPayoutForm;
	return (
		<div className='copy-offer-payouts-form display-flex-column'>
			<form
				className='ui-form payouts-form__main clearfix'
				onSubmit={props.handleSubmit(submit)}
			>
				<div className="ui-form__element">
					<Field
						name='affiliate_ids'
						placeholder={props.intl('Affiliate ids separated by comma')}
						component={InputField}
					/>
				</div>
				<div className="ui-form__element">
					<Field
						name="offer_from"
						placeholder='Source offer'
						multi={false}
						searchable={true}
						options={props.offersLookup}
						component={SelectField}
						showLabel={false}
					/>
				</div>
				<div className="ui-form__element">
					<Field
						name="offer_to"
						placeholder='Target offer'
						multi={false}
						searchable={true}
						options={props.offersLookup}
						component={SelectField}
						showLabel={false}
					/>
				</div>
				<div className="ui-form__element">
					<Field
						name="location_ids"
						placeholder='Locations (leave empty if all)'
						multi={true}
						searchable={true}
						options={props.locationsLookup}
						component={SelectField}
						showLabel={false}
					/>
				</div>
				<div className="ui-form__element">
					<Field
						name="is_hidden_geos_included"
						placeholder='Is hidden geos included'
						component={CheckboxField}
					/>
				</div>
				<button
					className={cn({
						'ui-btn': true,
						'ui-btn-primary apply': true
					})}
					type='submit'
				>{props.intl('Apply')}</button>
			</form>
		</div>
	);
};

Form.propTypes = {
	intl: PropTypes.func
};

const Main = props =>
	<ModalBox
		title={props.intl('Copy offer payouts within affiliate')}
		body={Form(props)}
		isOpen={props.isCopyOfferPayoutPopupOpen}
		onClose={props.toggleCopyOfferPayout}
		className='form-modal copy-offer-payouts-modal'
	/>;

Main.propTypes = {
	intl: PropTypes.func
};

export default reduxForm({
	form: 'formNameasdf12', enableReinitialize: true
})(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/forms/copy-offer-payouts/main.js